<ng-template #modalTankApprovals let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <fa-icon [icon]="icons.faShield"></fa-icon>
      <span>
        Operación Protegida
      </span>
    </h5>
    <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
      <fa-icon [icon]="icons.faTimes"></fa-icon>
    </button>
  </div>
  <div class="modal-body p-4">
    <ng-container [ngTemplateOutlet]="currentTemplate()"></ng-container>
  </div>
</ng-template>

<ng-template #auth>
  <form [formGroup]="authForm" (ngSubmit)="authentication()">
    <div class="form-group required mb-3">
      <label for="user" class="form-label ms-2">Usuario</label>
      <input type="text" class="form-control" id="user" formControlName="email" placeholder="Usuario">
      <div *ngIf="authForm.controls['email'].touched && authForm.controls['email'].invalid">
        <div *ngIf="authForm.controls['email'].errors?.['required']" class="text-danger text-sm">El usuario es
          requerido</div>
      </div>
    </div>

    <div class="form-group required mb-3">
      <label for="password" class="form-label ms-2">Contraseña</label>
      <input type="password" class="form-control" id="password" formControlName="password" placeholder="Contraseña">
      <div *ngIf="authForm.controls['password'].touched && authForm.controls['password'].invalid">
        <div *ngIf="authForm.controls['password'].errors?.['required']" class="text-danger text-sm">La contraseña es
          requerida</div>
      </div>
    </div>
    <div class="modal-actions">
      <button type="submit" class="btn btn-zazz-dark ms-2 shadow-sm">Autenticar</button>
    </div>
  </form>
</ng-template>

<ng-template #otpCode>
    <div class="form-group required mb-3">
      <label for="user" class="form-label ms-2">OTP</label>
      <input type="text" class="form-control" [(ngModel)]="otpData" [ngModelOptions]="{standalone: true}" placeholder="Código OTP">
    </div>
    <div class="modal-actions">
      <button (click)="validateOtp()" type="button" class="btn btn-zazz-dark ms-2 shadow-sm">Validar</button>
    </div>
</ng-template>